'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var paper = require('./paper-e6cfe656.js');

var StyledPaper = styled__default(paper.Paper)(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  padding: 4px 0;\n  background: ", ";\n  border: 1px solid ", ";\n  max-width: 432px;\n"], ["\n  padding: 4px 0;\n  background: ", ";\n  border: 1px solid ", ";\n  max-width: 432px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyLight;
});
var Item = styled__default.p(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  margin-top: 4px;\n  margin-bottom: 4px;\n  padding: 8px 16px;\n  font-family: ", ";\n  font-size: 14px;\n  line-height: 22px;\n  color: ", ";\n  cursor: pointer;\n  background: ", ";\n  &:hover {\n    background: ", ";\n  }\n"], ["\n  margin-top: 4px;\n  margin-bottom: 4px;\n  padding: 8px 16px;\n  font-family: ", ";\n  font-size: 14px;\n  line-height: 22px;\n  color: ", ";\n  cursor: pointer;\n  background: ", ";\n  &:hover {\n    background: ",
    ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminBlack;
}, function (_a) {
    var active = _a.active, theme = _a.theme;
    return (active ? theme.colors.greys.adminGreyMedium : theme.colors.universal.white);
}, function (_a) {
    var active = _a.active, theme = _a.theme;
    return (active ? theme.colors.greys.adminGreyMedium : theme.colors.greys.adminGreyLight);
});
var Menu = function (_a) {
    var items = _a.items, restProps = tslib_es6.__rest(_a, ["items"]);
    var handleClick = React.useCallback(function (item) { return function () {
        item.onClick();
    }; }, []);
    return (React__default.createElement(StyledPaper, tslib_es6.__assign({ depth: 2, borderRadius: "sm" }, restProps), items.map(function (item) { return (React__default.createElement(Item, { key: item.text, active: item.active, onClick: handleClick(item) }, item.text)); })));
};
var templateObject_1, templateObject_2;

exports.Menu = Menu;
